import {
  Calendar,
  CircleDollarSign,
  HammerIcon,
  Phone,
  Truck,
} from 'lucide-react';

import { SuggestionPipelines } from 'types/suggestions/CoreSuggestions';

const iconProps = { className: 'h-3.5 w-3.5 text-neutral-600' };

type SuggestionCategoryIconProps = {
  pipeline: SuggestionPipelines;
};

export const SuggestionCategoryIcon = ({
  pipeline,
}: SuggestionCategoryIconProps) => {
  switch (pipeline) {
    case SuggestionPipelines.QuickQuote:
      return <CircleDollarSign {...iconProps} />;
    case SuggestionPipelines.LoadBuilding:
      return <HammerIcon {...iconProps} />;
    case SuggestionPipelines.CarrierInfo:
      return <Truck {...iconProps} />;
    case SuggestionPipelines.ApptConfirmation:
      return <Calendar {...iconProps} />;
    case SuggestionPipelines.CheckCall:
      return <Phone {...iconProps} />;
    default:
      return null;
  }
};
